import { formatCurrency } from './utils';

const fmtDate = (d) => {
  if (!d) return 'N/A';
  if (typeof d === 'string' && d.includes('/')) return d;
  if (typeof d === 'string' && d.includes('-')) {
    const [y, m, day] = d.split('-');
    return `${m}/${day}/${y}`;
  }
  const dt = new Date(d + 'T12:00:00');
  return `${String(dt.getMonth() + 1).padStart(2, '0')}/${String(dt.getDate()).padStart(2, '0')}/${dt.getFullYear()}`;
};

const getCountryFullName = (country) => {
  if (!country) return '';
  const map = {
    'US': 'United States', 'USA': 'United States', 'United States': 'United States',
    'CA': 'Canada', 'Canada': 'Canada',
    'MX': 'Mexico', 'Mexico': 'Mexico',
    'UK': 'United Kingdom', 'GB': 'United Kingdom', 'United Kingdom': 'United Kingdom'
  };
  return map[country] || country;
};

const fmtAddr = (street, city, state, zip, country) => {
  const parts = [];
  if (street) parts.push(street);
  const csz = [city, state, zip].filter(Boolean).join(', ');
  if (csz) parts.push(csz);
  if (country) parts.push(getCountryFullName(country));
  return parts.join('<br/>');
};

const fmtCompanyAddr = (company) => {
  if (!company) return '';
  let addr = '';
  if (company.address) addr += company.address;
  if (company.city || company.state || company.zip_code) {
    addr += addr ? '<br/>' : '';
    if (company.city) addr += company.city;
    if (company.state) { if (company.city) addr += ', '; addr += company.state; }
    if (company.zip_code) { if (company.city || company.state) addr += ' '; addr += company.zip_code; }
  }
  if (company.country) { addr += addr ? '<br/>' : ''; addr += getCountryFullName(company.country); }
  return addr;
};

export const printInvoice = (invoice, lineItems, company, customers) => {
  const customer = (customers || []).find(c => c.id === invoice.customer_id);
  const companyAddr = fmtCompanyAddr(company);
  const billTo = fmtAddr(invoice.billing_street, invoice.billing_city, invoice.billing_state, invoice.billing_zip, invoice.billing_country);
  const shipTo = fmtAddr(invoice.shipping_street, invoice.shipping_city, invoice.shipping_state, invoice.shipping_zip, invoice.shipping_country);
  const validItems = (lineItems || []).filter(i => i.product_id);

  const content = `
    <div style="padding:16px;background:#fff;font-family:'Roboto','Helvetica','Arial',sans-serif;">

      <div style="display:flex;justify-content:space-between;margin-bottom:20px;">
        <div>
          <h1 style="margin:0 0 6px 0;font-size:1.75rem;font-weight:400;">INVOICE</h1>
          <p style="margin:2px 0;color:rgba(0,0,0,.6);font-size:.8rem;">Invoice #: ${invoice.invoice_number || 'N/A'}</p>
          <p style="margin:2px 0;color:rgba(0,0,0,.6);font-size:.8rem;">Date: ${fmtDate(invoice.invoice_date)}</p>
          <p style="margin:2px 0;color:rgba(0,0,0,.6);font-size:.8rem;">Due: ${fmtDate(invoice.due_date)}</p>
          ${invoice.purchase_order_number ? `<p style="margin:2px 0;color:rgba(0,0,0,.6);font-size:.8rem;">PI Ref: ${invoice.purchase_order_number}</p>` : ''}
          ${invoice.bill_of_lading_number ? `<p style="margin:2px 0;color:rgba(0,0,0,.6);font-size:.8rem;">BOL Ref: ${invoice.bill_of_lading_number}</p>` : ''}
          ${invoice.status ? `<p style="margin:4px 0;font-size:.8rem;font-weight:600;text-transform:uppercase;">${invoice.status}</p>` : ''}
        </div>
        <div style="text-align:right;">
          <h2 style="margin:0 0 6px 0;font-size:1.1rem;font-weight:500;">${company?.name || 'Your Company Name'}</h2>
          <p style="margin:1px 0;font-size:.8rem;">${companyAddr || 'Address not provided'}</p>
          ${company?.phone ? `<p style="margin:1px 0;font-size:.8rem;">Phone: ${company.phone}</p>` : ''}
          ${company?.email ? `<p style="margin:1px 0;font-size:.8rem;">Email: ${company.email}</p>` : ''}
          ${company?.website ? `<p style="margin:1px 0;font-size:.8rem;">Web: ${company.website}</p>` : ''}
        </div>
      </div>

      <div style="display:grid;grid-template-columns:1fr 1fr;gap:20px;margin-bottom:20px;">
        <div>
          <h3 style="margin:0 0 6px 0;font-weight:600;font-size:.9rem;">Bill To:</h3>
          ${invoice.customer_name ? `<p style="margin:2px 0;font-size:.8rem;">${invoice.customer_name}</p>` : ''}
          ${(invoice.customer_company || customer?.company) ? `<p style="margin:2px 0;font-size:.8rem;">${invoice.customer_company || customer?.company}</p>` : ''}
          ${customer?.phone ? `<p style="margin:2px 0;font-size:.8rem;">Phone: ${customer.phone}</p>` : ''}
          ${customer?.email ? `<p style="margin:2px 0;font-size:.8rem;">Email: ${customer.email}</p>` : ''}
          ${billTo ? `<p style="margin:12px 0 2px 0;font-size:.8rem;">Address:</p><p style="margin:2px 0;font-size:.8rem;">${billTo}</p>` : ''}
        </div>
        ${shipTo ? `
        <div>
          <h3 style="margin:0 0 6px 0;font-weight:600;font-size:.9rem;">Ship To:</h3>
          ${invoice.customer_name ? `<p style="margin:2px 0;font-size:.8rem;">${invoice.customer_name}</p>` : ''}
          ${(invoice.customer_company || customer?.company) ? `<p style="margin:2px 0;font-size:.8rem;">${invoice.customer_company || customer?.company}</p>` : ''}
          ${customer?.phone ? `<p style="margin:2px 0;font-size:.8rem;">Phone: ${customer.phone}</p>` : ''}
          ${customer?.email ? `<p style="margin:2px 0;font-size:.8rem;">Email: ${customer.email}</p>` : ''}
          <p style="margin:12px 0 2px 0;font-size:.8rem;">Address:</p><p style="margin:2px 0;font-size:.8rem;">${shipTo}</p>
        </div>` : ''}
      </div>

      <div style="margin:24px 0 12px 0;">
        <h3 style="margin:0 0 8px 0;padding-bottom:8px;font-weight:600;font-size:1.1rem;border-bottom:1px solid rgba(0,0,0,.12);">Order Summary</h3>
      </div>
      <div style="border:1px solid rgba(224,224,224,1);border-radius:4px;margin:16px 0;overflow:hidden;">
        <table style="width:100%;border-collapse:collapse;">
          <thead>
            <tr style="background-color:rgb(245,245,245);">
              <th style="padding:10px;text-align:left;font-weight:600;font-size:.8rem;border-bottom:1px solid rgba(224,224,224,1);">Product</th>
              <th style="padding:10px;text-align:center;font-weight:600;font-size:.8rem;border-bottom:1px solid rgba(224,224,224,1);">Size</th>
              <th style="padding:10px;text-align:center;font-weight:600;font-size:.8rem;border-bottom:1px solid rgba(224,224,224,1);">UoM</th>
              <th style="padding:10px;text-align:center;font-weight:600;font-size:.8rem;border-bottom:1px solid rgba(224,224,224,1);">Quantity</th>
              <th style="padding:10px;text-align:right;font-weight:600;font-size:.8rem;border-bottom:1px solid rgba(224,224,224,1);">Unit Price</th>
              <th style="padding:10px;text-align:right;font-weight:600;font-size:.8rem;border-bottom:1px solid rgba(224,224,224,1);">Amount</th>
            </tr>
          </thead>
          <tbody>
            ${validItems.map((item) => {
              const qty = parseFloat(item.quantity) || 0;
              const qtyLabel = item.unit_type === 'Unit'
                ? `${qty} ${qty === 1 ? 'Unit' : 'Units'}`
                : `${qty} ${qty === 1 ? 'Case' : 'Cases'}`;
              const uom = item.unit_type !== 'Unit' && item.units_per_case ? `${item.units_per_case}U/C` : '-';
              return `
            <tr>
              <td style="padding:8px 10px;border-bottom:1px solid rgba(224,224,224,1);font-size:.8rem;">${item.product_name || '—'}</td>
              <td style="padding:8px 10px;text-align:center;border-bottom:1px solid rgba(224,224,224,1);font-size:.8rem;">${item.variant_name || '-'}</td>
              <td style="padding:8px 10px;text-align:center;border-bottom:1px solid rgba(224,224,224,1);font-size:.8rem;">${uom}</td>
              <td style="padding:8px 10px;text-align:center;border-bottom:1px solid rgba(224,224,224,1);font-size:.8rem;">${qtyLabel}</td>
              <td style="padding:8px 10px;text-align:right;border-bottom:1px solid rgba(224,224,224,1);font-size:.8rem;">${formatCurrency(item.unit_price)}</td>
              <td style="padding:8px 10px;text-align:right;border-bottom:1px solid rgba(224,224,224,1);font-size:.8rem;">${formatCurrency(item.line_total || item.total_price)}</td>
            </tr>`;
            }).join('')}
          </tbody>
        </table>
      </div>

      <div style="display:flex;justify-content:flex-end;margin:16px 0;">
        <div style="width:250px;">
          <div style="display:flex;justify-content:space-between;margin:2px 0;">
            <span style="font-size:.85rem;">Subtotal:</span>
            <span style="font-size:.85rem;">${formatCurrency(invoice.subtotal)}</span>
          </div>
          ${parseFloat(invoice.discount) > 0 ? `
          <div style="display:flex;justify-content:space-between;margin:2px 0;">
            <span style="font-size:.85rem;">${invoice.discount_type === 'flat' ? 'Discount:' : `Discount (${invoice.discount}%):`}</span>
            <span style="font-size:.85rem;">-${formatCurrency(invoice.discount_amount)}</span>
          </div>` : ''}
          ${parseFloat(invoice.tax_amount) > 0 ? `
          <div style="display:flex;justify-content:space-between;margin:2px 0;">
            <span style="font-size:.85rem;">Tax (${invoice.tax_rate}%):</span>
            <span style="font-size:.85rem;">+${formatCurrency(invoice.tax_amount)}</span>
          </div>` : ''}
          ${parseFloat(invoice.shipping_fee) > 0 ? `
          <div style="display:flex;justify-content:space-between;margin:2px 0;">
            <span style="font-size:.85rem;">Shipping:</span>
            <span style="font-size:.85rem;">+${formatCurrency(invoice.shipping_fee)}</span>
          </div>` : ''}
          ${parseFloat(invoice.handling_fee) > 0 ? `
          <div style="display:flex;justify-content:space-between;margin:2px 0;">
            <span style="font-size:.85rem;">Handling:</span>
            <span style="font-size:.85rem;">+${formatCurrency(invoice.handling_fee)}</span>
          </div>` : ''}
          <div style="border-top:1px solid rgba(0,0,0,.12);padding-top:10px;margin-top:10px;">
            <div style="display:flex;justify-content:space-between;margin:2px 0;">
              <span style="font-size:1rem;font-weight:600;">Total:</span>
              <span style="font-size:1rem;font-weight:600;">${formatCurrency(invoice.total_before_credit)}</span>
            </div>
          </div>
          ${parseFloat(invoice.credit_applied) > 0 ? `
          <div style="display:flex;justify-content:space-between;margin:2px 0;">
            <span style="font-size:.85rem;color:rgb(46,125,50);">Credit Applied:</span>
            <span style="font-size:.85rem;color:rgb(46,125,50);">-${formatCurrency(invoice.credit_applied)}</span>
          </div>
          <div style="border-top:1px solid rgba(0,0,0,.12);padding-top:5px;margin-top:5px;">
            <div style="display:flex;justify-content:space-between;margin:2px 0;">
              <span style="font-size:1rem;font-weight:600;">Amount Due:</span>
              <span style="font-size:1rem;font-weight:600;">${formatCurrency(invoice.amount_due)}</span>
            </div>
          </div>` : ''}
        </div>
      </div>

      ${(invoice.payment_terms || invoice.payment_method || parseFloat(invoice.late_fee_rate) > 0 || parseFloat(invoice.early_payment_discount) > 0 || parseInt(invoice.early_payment_days) > 0) ? `
      <div style="margin:16px 0;">
        <h3 style="margin:0 0 6px 0;font-weight:600;font-size:.9rem;">Payment Terms:</h3>
        ${invoice.payment_terms ? `<p style="margin:2px 0;font-size:.8rem;">Payment Due: ${invoice.payment_terms}</p>` : ''}
        ${invoice.payment_method ? `<p style="margin:2px 0;font-size:.8rem;">Preferred Method: ${invoice.payment_method}</p>` : ''}
        ${(parseFloat(invoice.early_payment_discount) > 0 || parseInt(invoice.early_payment_days) > 0) ? `<p style="margin:2px 0;font-size:.8rem;">Early Payment: ${parseFloat(invoice.early_payment_discount) > 0 ? `${invoice.early_payment_discount}% discount if paid within ` : 'Due within '}${invoice.early_payment_days || 0} days</p>` : ''}
        ${parseFloat(invoice.late_fee_rate) > 0 ? `<p style="margin:2px 0;font-size:.8rem;">Late Fee: ${invoice.late_fee_rate}% per month on overdue balances</p>` : ''}
      </div>` : ''}

      ${invoice.notes ? `<div style="margin:16px 0;"><h3 style="margin:0 0 6px 0;font-weight:600;font-size:.9rem;">Notes:</h3><p style="margin:6px 0;white-space:pre-line;font-size:.8rem;">${invoice.notes}</p></div>` : ''}
      ${invoice.special_instructions ? `<div style="margin:16px 0;"><h3 style="margin:0 0 6px 0;font-weight:600;font-size:.9rem;">Special Instructions:</h3><p style="margin:6px 0;white-space:pre-line;font-size:.8rem;">${invoice.special_instructions}</p></div>` : ''}

      ${invoice.terms_and_conditions ? `
      <div class="terms-box" style="margin:20px 0;padding:16px;border:1px solid #000;">
        <h3 style="margin:0 0 10px 0;font-weight:600;font-size:.9rem;">Terms & Conditions</h3>
        <p style="margin:0;white-space:pre-line;font-size:.75rem;line-height:1.4;">${invoice.terms_and_conditions}</p>
      </div>` : ''}

      <div style="margin-top:20px;display:flex;justify-content:space-between;align-items:flex-end;">
        <div style="text-align:center;">
          <p style="font-size:.8rem;color:rgba(0,0,0,.6);">Thank you for your business!</p>
        </div>
        ${invoice.prepared_by?.name ? `
        <div style="text-align:right;min-width:200px;break-inside:avoid;">
          <p style="margin:2px 0;font-size:.8rem;font-weight:600;">Prepared by:</p>
          <div style="font-family:'Brush Script MT','Brush Script Std',cursive;font-size:16pt;color:#000;margin:6px 0;text-shadow:1px 1px 1px rgba(0,0,0,.1);">${invoice.prepared_by.name}</div>
          <p style="margin:1px 0;font-size:.8rem;color:rgba(0,0,0,.6);">${invoice.prepared_by.position || 'Sales Representative'}</p>
          <p style="margin:1px 0;font-size:.75rem;color:rgba(0,0,0,.6);">${fmtDate(invoice.prepared_by.date)}</p>
        </div>` : ''}
      </div>
    </div>
  `;

  const html = `<!DOCTYPE html><html><head>
    <title>Invoice ${invoice.invoice_number || ''}</title>
    <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap" rel="stylesheet">
    <style>
      @page{size:auto;margin:.3in}
      @media print{body{-webkit-print-color-adjust:exact;print-color-adjust:exact}.terms-box{box-decoration-break:clone;-webkit-box-decoration-break:clone}}
      body{margin:0;font-family:'Roboto','Helvetica','Arial',sans-serif;line-height:1.3;letter-spacing:.01071em;background:white;}
      .terms-box{box-decoration-break:clone;-webkit-box-decoration-break:clone}
    </style>
  </head><body>${content}</body></html>`;

  const w = window.open('', '_blank', 'width=800,height=600');
  w.document.write(html);
  w.document.close();
  w.onload = () => { w.focus(); w.print(); setTimeout(() => w.close(), 1000); };
};

export const generateInvoiceHTML = (invoice, lineItems, company, customers) => {
  const customer = (customers || []).find(c => c.id === invoice.customer_id);
  const companyAddr = fmtCompanyAddr(company);
  const billTo = fmtAddr(invoice.billing_street, invoice.billing_city, invoice.billing_state, invoice.billing_zip, invoice.billing_country);
  const shipTo = fmtAddr(invoice.shipping_street, invoice.shipping_city, invoice.shipping_state, invoice.shipping_zip, invoice.shipping_country);
  const validItems = (lineItems || []).filter(i => i.product_id);

  const content = `
    <div style="padding:16px;background:#fff;font-family:'Roboto','Helvetica','Arial',sans-serif;">

      <div style="display:flex;justify-content:space-between;margin-bottom:20px;">
        <div>
          <h1 style="margin:0 0 6px 0;font-size:1.75rem;font-weight:400;">INVOICE</h1>
          <p style="margin:2px 0;color:rgba(0,0,0,.6);font-size:.8rem;">Invoice #: ${invoice.invoice_number || 'N/A'}</p>
          <p style="margin:2px 0;color:rgba(0,0,0,.6);font-size:.8rem;">Date: ${fmtDate(invoice.invoice_date)}</p>
          <p style="margin:2px 0;color:rgba(0,0,0,.6);font-size:.8rem;">Due: ${fmtDate(invoice.due_date)}</p>
          ${invoice.purchase_order_number ? `<p style="margin:2px 0;color:rgba(0,0,0,.6);font-size:.8rem;">PI Ref: ${invoice.purchase_order_number}</p>` : ''}
          ${invoice.bill_of_lading_number ? `<p style="margin:2px 0;color:rgba(0,0,0,.6);font-size:.8rem;">BOL Ref: ${invoice.bill_of_lading_number}</p>` : ''}
          ${invoice.status ? `<p style="margin:4px 0;font-size:.8rem;font-weight:600;text-transform:uppercase;">${invoice.status}</p>` : ''}
        </div>
        <div style="text-align:right;">
          <h2 style="margin:0 0 6px 0;font-size:1.1rem;font-weight:500;">${company?.name || 'Your Company Name'}</h2>
          <p style="margin:1px 0;font-size:.8rem;">${companyAddr || 'Address not provided'}</p>
          ${company?.phone ? `<p style="margin:1px 0;font-size:.8rem;">Phone: ${company.phone}</p>` : ''}
          ${company?.email ? `<p style="margin:1px 0;font-size:.8rem;">Email: ${company.email}</p>` : ''}
          ${company?.website ? `<p style="margin:1px 0;font-size:.8rem;">Web: ${company.website}</p>` : ''}
        </div>
      </div>

      <div style="display:grid;grid-template-columns:1fr 1fr;gap:20px;margin-bottom:20px;">
        <div>
          <h3 style="margin:0 0 6px 0;font-weight:600;font-size:.9rem;">Bill To:</h3>
          ${invoice.customer_name ? `<p style="margin:2px 0;font-size:.8rem;">${invoice.customer_name}</p>` : ''}
          ${(invoice.customer_company || customer?.company) ? `<p style="margin:2px 0;font-size:.8rem;">${invoice.customer_company || customer?.company}</p>` : ''}
          ${customer?.phone ? `<p style="margin:2px 0;font-size:.8rem;">Phone: ${customer.phone}</p>` : ''}
          ${customer?.email ? `<p style="margin:2px 0;font-size:.8rem;">Email: ${customer.email}</p>` : ''}
          ${billTo ? `<p style="margin:12px 0 2px 0;font-size:.8rem;">Address:</p><p style="margin:2px 0;font-size:.8rem;">${billTo}</p>` : ''}
        </div>
        ${shipTo ? `
        <div>
          <h3 style="margin:0 0 6px 0;font-weight:600;font-size:.9rem;">Ship To:</h3>
          ${invoice.customer_name ? `<p style="margin:2px 0;font-size:.8rem;">${invoice.customer_name}</p>` : ''}
          ${(invoice.customer_company || customer?.company) ? `<p style="margin:2px 0;font-size:.8rem;">${invoice.customer_company || customer?.company}</p>` : ''}
          ${customer?.phone ? `<p style="margin:2px 0;font-size:.8rem;">Phone: ${customer.phone}</p>` : ''}
          ${customer?.email ? `<p style="margin:2px 0;font-size:.8rem;">Email: ${customer.email}</p>` : ''}
          <p style="margin:12px 0 2px 0;font-size:.8rem;">Address:</p><p style="margin:2px 0;font-size:.8rem;">${shipTo}</p>
        </div>` : ''}
      </div>

      <div style="margin:24px 0 12px 0;">
        <h3 style="margin:0 0 8px 0;padding-bottom:8px;font-weight:600;font-size:1.1rem;border-bottom:1px solid rgba(0,0,0,.12);">Order Summary</h3>
      </div>
      <div style="border:1px solid rgba(224,224,224,1);border-radius:4px;margin:16px 0;overflow:hidden;">
        <table style="width:100%;border-collapse:collapse;">
          <thead>
            <tr style="background-color:rgb(245,245,245);">
              <th style="padding:10px;text-align:left;font-weight:600;font-size:.8rem;border-bottom:1px solid rgba(224,224,224,1);">Product</th>
              <th style="padding:10px;text-align:center;font-weight:600;font-size:.8rem;border-bottom:1px solid rgba(224,224,224,1);">Size</th>
              <th style="padding:10px;text-align:center;font-weight:600;font-size:.8rem;border-bottom:1px solid rgba(224,224,224,1);">UoM</th>
              <th style="padding:10px;text-align:center;font-weight:600;font-size:.8rem;border-bottom:1px solid rgba(224,224,224,1);">Quantity</th>
              <th style="padding:10px;text-align:right;font-weight:600;font-size:.8rem;border-bottom:1px solid rgba(224,224,224,1);">Unit Price</th>
              <th style="padding:10px;text-align:right;font-weight:600;font-size:.8rem;border-bottom:1px solid rgba(224,224,224,1);">Amount</th>
            </tr>
          </thead>
          <tbody>
            ${validItems.map((item) => {
              const qty = parseFloat(item.quantity) || 0;
              const qtyLabel = item.unit_type === 'Unit'
                ? `${qty} ${qty === 1 ? 'Unit' : 'Units'}`
                : `${qty} ${qty === 1 ? 'Case' : 'Cases'}`;
              const uom = item.unit_type !== 'Unit' && item.units_per_case ? `${item.units_per_case}U/C` : '-';
              return `
            <tr>
              <td style="padding:8px 10px;border-bottom:1px solid rgba(224,224,224,1);font-size:.8rem;">${item.product_name || '—'}</td>
              <td style="padding:8px 10px;text-align:center;border-bottom:1px solid rgba(224,224,224,1);font-size:.8rem;">${item.variant_name || '-'}</td>
              <td style="padding:8px 10px;text-align:center;border-bottom:1px solid rgba(224,224,224,1);font-size:.8rem;">${uom}</td>
              <td style="padding:8px 10px;text-align:center;border-bottom:1px solid rgba(224,224,224,1);font-size:.8rem;">${qtyLabel}</td>
              <td style="padding:8px 10px;text-align:right;border-bottom:1px solid rgba(224,224,224,1);font-size:.8rem;">${formatCurrency(item.unit_price)}</td>
              <td style="padding:8px 10px;text-align:right;border-bottom:1px solid rgba(224,224,224,1);font-size:.8rem;">${formatCurrency(item.line_total || item.total_price)}</td>
            </tr>`;
            }).join('')}
          </tbody>
        </table>
      </div>

      <div style="display:flex;justify-content:flex-end;margin:16px 0;">
        <div style="width:250px;">
          <div style="display:flex;justify-content:space-between;margin:2px 0;">
            <span style="font-size:.85rem;">Subtotal:</span>
            <span style="font-size:.85rem;">${formatCurrency(invoice.subtotal)}</span>
          </div>
          ${parseFloat(invoice.discount) > 0 ? `
          <div style="display:flex;justify-content:space-between;margin:2px 0;">
            <span style="font-size:.85rem;">${invoice.discount_type === 'flat' ? 'Discount:' : `Discount (${invoice.discount}%):`}</span>
            <span style="font-size:.85rem;">-${formatCurrency(invoice.discount_amount)}</span>
          </div>` : ''}
          ${parseFloat(invoice.tax_amount) > 0 ? `
          <div style="display:flex;justify-content:space-between;margin:2px 0;">
            <span style="font-size:.85rem;">Tax (${invoice.tax_rate}%):</span>
            <span style="font-size:.85rem;">+${formatCurrency(invoice.tax_amount)}</span>
          </div>` : ''}
          ${parseFloat(invoice.shipping_fee) > 0 ? `
          <div style="display:flex;justify-content:space-between;margin:2px 0;">
            <span style="font-size:.85rem;">Shipping:</span>
            <span style="font-size:.85rem;">+${formatCurrency(invoice.shipping_fee)}</span>
          </div>` : ''}
          ${parseFloat(invoice.handling_fee) > 0 ? `
          <div style="display:flex;justify-content:space-between;margin:2px 0;">
            <span style="font-size:.85rem;">Handling:</span>
            <span style="font-size:.85rem;">+${formatCurrency(invoice.handling_fee)}</span>
          </div>` : ''}
          <div style="border-top:1px solid rgba(0,0,0,.12);padding-top:10px;margin-top:10px;">
            <div style="display:flex;justify-content:space-between;margin:2px 0;">
              <span style="font-size:1rem;font-weight:600;">Total:</span>
              <span style="font-size:1rem;font-weight:600;">${formatCurrency(invoice.total_before_credit)}</span>
            </div>
          </div>
          ${parseFloat(invoice.credit_applied) > 0 ? `
          <div style="display:flex;justify-content:space-between;margin:2px 0;">
            <span style="font-size:.85rem;color:rgb(46,125,50);">Credit Applied:</span>
            <span style="font-size:.85rem;color:rgb(46,125,50);">-${formatCurrency(invoice.credit_applied)}</span>
          </div>
          <div style="border-top:1px solid rgba(0,0,0,.12);padding-top:5px;margin-top:5px;">
            <div style="display:flex;justify-content:space-between;margin:2px 0;">
              <span style="font-size:1rem;font-weight:600;">Amount Due:</span>
              <span style="font-size:1rem;font-weight:600;">${formatCurrency(invoice.amount_due)}</span>
            </div>
          </div>` : ''}
        </div>
      </div>

      ${(invoice.payment_terms || invoice.payment_method || parseFloat(invoice.late_fee_rate) > 0 || parseFloat(invoice.early_payment_discount) > 0 || parseInt(invoice.early_payment_days) > 0) ? `
      <div style="margin:16px 0;">
        <h3 style="margin:0 0 6px 0;font-weight:600;font-size:.9rem;">Payment Terms:</h3>
        ${invoice.payment_terms ? `<p style="margin:2px 0;font-size:.8rem;">Payment Due: ${invoice.payment_terms}</p>` : ''}
        ${invoice.payment_method ? `<p style="margin:2px 0;font-size:.8rem;">Preferred Method: ${invoice.payment_method}</p>` : ''}
        ${(parseFloat(invoice.early_payment_discount) > 0 || parseInt(invoice.early_payment_days) > 0) ? `<p style="margin:2px 0;font-size:.8rem;">Early Payment: ${parseFloat(invoice.early_payment_discount) > 0 ? `${invoice.early_payment_discount}% discount if paid within ` : 'Due within '}${invoice.early_payment_days || 0} days</p>` : ''}
        ${parseFloat(invoice.late_fee_rate) > 0 ? `<p style="margin:2px 0;font-size:.8rem;">Late Fee: ${invoice.late_fee_rate}% per month on overdue balances</p>` : ''}
      </div>` : ''}

      ${invoice.notes ? `<div style="margin:16px 0;"><h3 style="margin:0 0 6px 0;font-weight:600;font-size:.9rem;">Notes:</h3><p style="margin:6px 0;white-space:pre-line;font-size:.8rem;">${invoice.notes}</p></div>` : ''}
      ${invoice.special_instructions ? `<div style="margin:16px 0;"><h3 style="margin:0 0 6px 0;font-weight:600;font-size:.9rem;">Special Instructions:</h3><p style="margin:6px 0;white-space:pre-line;font-size:.8rem;">${invoice.special_instructions}</p></div>` : ''}

      ${invoice.terms_and_conditions ? `
      <div class="terms-box" style="margin:20px 0;padding:16px;border:1px solid #000;">
        <h3 style="margin:0 0 10px 0;font-weight:600;font-size:.9rem;">Terms & Conditions</h3>
        <p style="margin:0;white-space:pre-line;font-size:.75rem;line-height:1.4;">${invoice.terms_and_conditions}</p>
      </div>` : ''}

      <div style="margin-top:20px;display:flex;justify-content:space-between;align-items:flex-end;">
        <div style="text-align:center;">
          <p style="font-size:.8rem;color:rgba(0,0,0,.6);">Thank you for your business!</p>
        </div>
        ${invoice.prepared_by?.name ? `
        <div style="text-align:right;min-width:200px;break-inside:avoid;">
          <p style="margin:2px 0;font-size:.8rem;font-weight:600;">Prepared by:</p>
          <div style="font-family:'Brush Script MT','Brush Script Std',cursive;font-size:16pt;color:#000;margin:6px 0;text-shadow:1px 1px 1px rgba(0,0,0,.1);">${invoice.prepared_by.name}</div>
          <p style="margin:1px 0;font-size:.8rem;color:rgba(0,0,0,.6);">${invoice.prepared_by.position || 'Sales Representative'}</p>
          <p style="margin:1px 0;font-size:.75rem;color:rgba(0,0,0,.6);">${fmtDate(invoice.prepared_by.date)}</p>
        </div>` : ''}
      </div>
    </div>
  `;

  return `<!DOCTYPE html><html><head>
    <title>Invoice ${invoice.invoice_number || ''}</title>
    <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap" rel="stylesheet">
    <style>
      @page{size:auto;margin:.3in}
      @media print{body{-webkit-print-color-adjust:exact;print-color-adjust:exact}.terms-box{box-decoration-break:clone;-webkit-box-decoration-break:clone}}
      body{margin:0;font-family:'Roboto','Helvetica','Arial',sans-serif;line-height:1.3;letter-spacing:.01071em;background:white;}
      .terms-box{box-decoration-break:clone;-webkit-box-decoration-break:clone}
    </style>
  </head><body>${content}</body></html>`;
};
